<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="text-h5 text-center d-block pt-6">
        Tervetuloa uudistuneeseen Noormarkun VPK:n sovellukseen!
      </v-card-title>
      <v-card-text class="text-center pb-0">
        <p class="subtitle-1 grey--text text--darken-1">
          Olemme päivittäneet sovelluksen ulkoasua modernimmaksi ja
          helppokäyttöisemmäksi.
          <br />
          Valitse alta mieleisesi ulkoasu. Voit vaihtaa valintaa myöhemmin
          valikosta kohdasta "Moderni ulkoasu".
        </p>
      </v-card-text>

      <v-card-text class="pt-4">
        <v-row>
          <!-- Modern Theme Option -->
          <v-col cols="12" md="6">
            <v-card
              outlined
              class="cursor-pointer transition-swing"
              :class="{
                'primary ring-border': selectedTheme === true,
                'grey lighten-4': selectedTheme !== true,
              }"
              @click="selectTheme(true)"
              height="100%"
            >
              <v-card-text class="text-center">
                <div class="text-h6 mb-4 font-weight-bold black--text">
                  Moderni
                </div>
                <!-- Visual Representation of Modern Theme -->
                <v-sheet
                  color="#f4f7f6"
                  height="160"
                  width="100%"
                  class="d-flex flex-column align-center justify-center rounded-lg mx-auto elevation-1 overflow-hidden"
                  style="position: relative; border: 1px solid #eee"
                >
                  <!-- App Bar -->
                  <div
                    style="
                      width: 100%;
                      height: 24px;
                      background: white;
                      position: absolute;
                      top: 0;
                      left: 0;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    "
                    class="d-flex align-center px-2"
                  >
                    <div
                      style="
                        width: 12px;
                        height: 12px;
                        background: #b71c1c;
                        border-radius: 2px;
                      "
                    ></div>
                    <div
                      style="
                        width: 60px;
                        height: 6px;
                        background: #b71c1c;
                        margin-left: 8px;
                        border-radius: 4px;
                        opacity: 0.8;
                      "
                    ></div>
                  </div>
                  <!-- Content Card -->
                  <div
                    style="
                      width: 80%;
                      height: 80px;
                      background: white;
                      border-radius: 12px;
                      margin-top: 20px;
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                    "
                    class="d-flex flex-column pa-2"
                  >
                    <div
                      style="
                        width: 40%;
                        height: 8px;
                        background: #eee;
                        border-radius: 4px;
                        margin-bottom: 8px;
                      "
                    ></div>
                    <div
                      style="
                        width: 90%;
                        height: 6px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        margin-bottom: 4px;
                      "
                    ></div>
                    <div
                      style="
                        width: 70%;
                        height: 6px;
                        background: #f5f5f5;
                        border-radius: 4px;
                      "
                    ></div>
                    <div class="mt-auto d-flex justify-end">
                      <div
                        style="
                          width: 24px;
                          height: 24px;
                          border: 2px solid #b71c1c;
                          border-radius: 8px;
                        "
                      ></div>
                    </div>
                  </div>
                </v-sheet>
                <div class="mt-4 body-2 black--text">
                  Vaalea, ilmava, pyöristetyt kulmat, Open Sans -fontti.
                </div>
              </v-card-text>
              <v-fade-transition>
                <v-overlay
                  v-if="selectedTheme === true"
                  absolute
                  color="primary"
                  opacity="0.1"
                >
                  <v-icon x-large color="primary">mdi-check-circle</v-icon>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </v-col>

          <!-- Classic Theme Option -->
          <v-col cols="12" md="6">
            <v-card
              outlined
              class="cursor-pointer transition-swing"
              :class="{
                'primary ring-border': selectedTheme === false,
                'grey lighten-4': selectedTheme !== false,
              }"
              @click="selectTheme(false)"
              height="100%"
            >
              <v-card-text class="text-center">
                <div class="text-h6 mb-4 font-weight-bold black--text">
                  Perinteinen
                </div>
                <!-- Visual Representation of Classic Theme -->
                <v-sheet
                  color="#fafafa"
                  height="160"
                  width="100%"
                  class="d-flex flex-column align-center justify-center mx-auto elevation-1 overflow-hidden"
                  style="position: relative; border: 1px solid #eee"
                >
                  <!-- App Bar -->
                  <div
                    style="
                      width: 100%;
                      height: 24px;
                      background: #6c0000;
                      position: absolute;
                      top: 0;
                      left: 0;
                      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                    "
                    class="d-flex align-center px-2"
                  >
                    <div
                      style="
                        width: 12px;
                        height: 12px;
                        background: white;
                        border-radius: 2px;
                      "
                    ></div>
                    <div
                      style="
                        width: 60px;
                        height: 6px;
                        background: white;
                        margin-left: 8px;
                        border-radius: 0px;
                      "
                    ></div>
                  </div>
                  <!-- Content Card -->
                  <div
                    style="
                      width: 80%;
                      height: 80px;
                      background: white;
                      border-radius: 2px;
                      margin-top: 20px;
                      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    "
                    class="d-flex flex-column pa-2"
                  >
                    <div
                      style="
                        width: 40%;
                        height: 8px;
                        background: #eee;
                        border-radius: 0px;
                        margin-bottom: 8px;
                      "
                    ></div>
                    <div
                      style="
                        width: 90%;
                        height: 6px;
                        background: #f5f5f5;
                        border-radius: 0px;
                        margin-bottom: 4px;
                      "
                    ></div>
                    <div
                      style="
                        width: 70%;
                        height: 6px;
                        background: #f5f5f5;
                        border-radius: 0px;
                      "
                    ></div>
                    <div class="mt-auto d-flex justify-end">
                      <div
                        style="
                          width: 24px;
                          height: 24px;
                          background: #6c0000;
                          border-radius: 4px;
                        "
                      ></div>
                    </div>
                  </div>
                </v-sheet>
                <div class="mt-4 body-2 black--text">
                  Tuttu ja turvallinen, terävät kulmat, kompakti.
                </div>
              </v-card-text>
              <v-fade-transition>
                <v-overlay
                  v-if="selectedTheme === false"
                  absolute
                  color="primary"
                  opacity="0.1"
                >
                  <v-icon x-large color="primary">mdi-check-circle</v-icon>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pb-6 pt-2 justify-center">
        <v-btn
          color="primary"
          x-large
          width="200"
          @click="saveAndClose"
          class="elevation-2"
        >
          Ota käyttöön
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ThemeSelectionDialog",
  data() {
    return {
      dialog: false,
      selectedTheme: true, // Default to modern
    };
  },
  watch: {
    $route() {
      this.checkShowDialog();
    },
  },
  mounted() {
    this.checkShowDialog();
  },
  methods: {
    checkShowDialog() {
      const shown = localStorage.getItem("theme_selection_shown");
      const isExcludedRoute = ["Login", "PublicShoppingList"].includes(
        this.$route.name
      );
      const isLoggedIn = !!this.$store.state.user;

      if (!shown && !isExcludedRoute && isLoggedIn && !this.dialog) {
        // If not shown, check current store state or default to true
        this.selectedTheme = this.$store.state.modernTheme;
        this.dialog = true;
      }
    },
    selectTheme(isModern) {
      this.selectedTheme = isModern;
      if (this.$store.state.modernTheme !== isModern) {
        this.$store.dispatch("toggleModernTheme");
      }
    },
    saveAndClose() {
      localStorage.setItem("theme_selection_shown", "true");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.ring-border {
  border: 2px solid var(--v-primary-base) !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
